export var CallPriority;
(function (CallPriority) {
    CallPriority[CallPriority["HIGH"] = 1] = "HIGH";
    CallPriority[CallPriority["NORMAL"] = 0] = "NORMAL";
})(CallPriority || (CallPriority = {}));
//# sourceMappingURL=call-priority.js.map